import {Injectable}            from '@angular/core';
import {UploadProgressOptions} from '../../types/common-types';

/**
 * Service for simulating file upload progress
 */
@Injectable({providedIn: 'root'})
export class UploadFileService {
  /**
   * Simulates file upload progress with incremental updates
   * @param callback - Progress update function, returns true when need to stop and false in case need to continue
   * @param options - Optional settings for increment speed and interval timing
   * @public
   */
  public controlUploadProgress(callback: (progress: number) => boolean, options?: UploadProgressOptions): void {
    let initialProgress = 0;
    const incrementValue = options?.Increment ?? 9;
    const intervalValue = options?.Interval ?? 100;
    const progressInterval = setInterval(() => {
      initialProgress += incrementValue;
      if (initialProgress >= 100) {
        initialProgress = 99;
      }
      const shouldContinueInterval = callback(initialProgress);
      // Stop if callback returns true or progress is complete
      if (shouldContinueInterval || initialProgress === 99) {
        clearInterval(progressInterval);
      }
    }, intervalValue);
  }
}
